import I18N from '@leverege/i18n'
import { DataViewerModel } from '@leverege/molten/data-viewers'

import EventsView from '../events/EventsView'
import EventsViewModel from '../events/EventsViewModel'

import ShelfSupportDataViewer from './ShelfSupportDataViewer'

const { tf, tfIcon } = I18N.ns( 'ps.dataViewers.ShelfMonitoringEventsDataViewer' )

export default {
  id : 'ps.dataViewers.ShelfMonitoringEventsDataViewer',
  type : 'ps.ShelfMonitoringEvents',
  name : tf( 'name' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : [ 'main', 'card' ],
  matches : { type : [ 'GroupDataViewer' ], objectType : 'segment' },
  createSettings : ( props ) => {

    return EventsViewModel.create( {
      dataViewers : [ 
        DataViewerModel.create( 
          ShelfSupportDataViewer.type, 
          ShelfSupportDataViewer.createSettings( props ) )
      ],
      breakpoints : [ 'minWidth' ]
    }, { getAllPages : false,
         options : {
           perPage : 100,
           range : 'last7Days',
         }, } )
  },
  component : EventsView,
  getDefaultCardContentOptions : { height : '400px' }
}
